define('lq/uploader',[
    'jquery',
    'lq',
    'lq/fileUpload'
], function ($, lq, FileUpload) {


    function Uploader(piping, dropId) {
        this.piping = piping;
        this.dropId = dropId;
        this.targetDiv = $('<div />')
            .hide()
            .appendTo($('body'));
        this.onStartingUploadCallback = $.noop;
        this.onFileUploadedCallback = $.noop;
        this.onUploadFinishedCallback = $.noop;
    };

    Uploader.prototype.withParameters = function (params) {
        this.params = params;
        return this;
    };

    Uploader.prototype.toTenantUrl = function (path) {
        this.url = lq.getTenantUrl(path);
        return this;
    };

    Uploader.prototype.withFileFilter = function (filter) {
        this.filter = filter;
        return this;
    };

    Uploader.prototype.withMaxFileSize = function (maxFileSizeInKb) {
        this.maxFileSizeInKb = maxFileSizeInKb;
        return this;
    };

    Uploader.prototype.withSmartphoneMode = function (mode) {
        this.smartphoneMode = mode;
        return this;
    };

    Uploader.prototype.withPhotoQuality = function (value) {
        this.photoQuality = value;
        return this;
    };

    Uploader.prototype.withMaxImageDimensions = function (maxImageDimensions) {
        this.maxImageDimensions = maxImageDimensions;
        return this;
    };

    Uploader.prototype.onMaxFileSizeExceeded = function (onMaxFileSizeExceededCallback) {
        this.onMaxFileSizeExceededCallback = onMaxFileSizeExceededCallback;
        return this;
    };

    Uploader.prototype.onFileUploadCancel = function (fileUploadCancelCallback) {
        this.fileUploadCancelCallback = fileUploadCancelCallback;
        return this;
    };

    Uploader.prototype.onInvalidFileExtension = function (onInvalidFileExtensionCallback) {
        this.onInvalidFileExtensionCallback = onInvalidFileExtensionCallback;
        return this;
    }

    Uploader.prototype.onStartingUpload = function (onStartingUploadCallback) {
        this.onStartingUploadCallback = onStartingUploadCallback;
        return this;
    };

    Uploader.prototype.onFileUploaded = function (onFileUploadedCallback) {
        this.onFileUploadedCallback = onFileUploadedCallback;
        return this;
    };

    Uploader.prototype.onUploadFinished = function (onUploadFinishedCallback) {
        this.onUploadFinishedCallback = onUploadFinishedCallback;
        return this;
    };

    Uploader.prototype.uploadSingleFile = function () {
        this._doUpload(false);
    };

    Uploader.prototype.uploadMultipleSpecificFiles = function (specificFiles) {
        // This case the first parameter does not matter
        // if we alway pass an array as a second param
        this._doUpload(undefined, specificFiles);
    };

    Uploader.prototype.uploadMultipleFiles = function () {
        this._doUpload(true);
    };

    Uploader.prototype._doUpload = function (allowMultipleUploads, specificFiles) {
        this._doNormalUpload(allowMultipleUploads, specificFiles);
    };

    Uploader.prototype._doNormalUpload = function (allowMultipleUploads, specificFiles) {
        var self = this;

        var counter = 0;

        var upload = new FileUpload({
            action: this.url,
            params: this.params,
            maxFileSizeInKb: this.maxFileSizeInKb,
            maxImageDimensions: this.maxImageDimensions,
            accept: this.filter,
            multiple: allowMultipleUploads,
            actionId: this.piping.actionId,
            dropId: this.dropId,
            specificFiles: specificFiles,
            onMaxFileSizeExceeded: function (filename, maxFileSizeInKb) {
                self._maxFileSizeExceeded(filename, maxFileSizeInKb);
            },
            onFileUploadCancel: self.fileUploadCancelCallback,
            onInvalidFileExtension: function (filename) {
                if (!self.onInvalidFileExtensionCallback) {
                    alert('File upload rejected: "' + filename + '" is not a permitted file.');
                }  else {
                    self.onInvalidFileExtensionCallback(filename);
                }
            },
            onStart: function () {
                self.piping.busyIndicator.showWithCount(counter);

                self.$label = $('<span />')
                    .text('Uploading');
                self.$percentage = $('<span />')
                    .text('0%');
                self.$progressBar = $('<div class="uploader-progress-foreground" />')
                    .css('width', '0%');                    ;

                self.piping.busyIndicator.showElement($('<div class="uploader-progress-indicator" />')
                    .append($('<div class="uploader-progress-label" />')
                        .append(self.$label)
                        .append(self.$percentage))
                    .append($('<div />')
                        .append($('<div class="uploader-progress-background" />')
                            .append(self.$progressBar))));

                self.onStartingUploadCallback(upload);
            },
            onUploadingFile: function (total, uploaded) {
                if (total > 1) {
                    self.$label.text(`Uploading (${uploaded + 1}/${total})`);
                }
                self.$progressBar.css('width', '0%');
            },
            onFileUploading: function (percentage) {
                self.$percentage.text(`${percentage}%`);
                self.$progressBar.css('width', `${percentage}%`);
            },
            onFileUploaded: function (response) {
                self.onFileUploadedCallback(response);
            },
            onFinished: function () {
                self.piping.busyIndicator.removeElement();
                self.onUploadFinishedCallback();
            }
        });

        counter = this.piping.busyIndicator.forceHide();

        upload.do();
    };

    Uploader.prototype._maxFileSizeExceeded = function (filename, maxFileSize) {
        if (!this.onMaxFileSizeExceededCallback) {
            alert(filename + ' is too large, maximum file size is ' + (maxFileSize || this.maxFileSizeInKb) + 'KB');
        } else {
            this.onMaxFileSizeExceededCallback(filename, maxFileSize);
        }
    }

    return Uploader;
});
